import { render, staticRenderFns } from "./FileEntryActions.vue?vue&type=template&id=4ba2bfc0&scoped=true"
import script from "./FileEntryActions.vue?vue&type=script&lang=ts"
export * from "./FileEntryActions.vue?vue&type=script&lang=ts"
import style0 from "./FileEntryActions.vue?vue&type=style&index=0&id=4ba2bfc0&prod&lang=scss"
import style1 from "./FileEntryActions.vue?vue&type=style&index=1&id=4ba2bfc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2bfc0",
  null
  
)

export default component.exports